.section {
  margin-bottom: 16px;
}

.heading {
  font-size: 1.25rem;
  margin-bottom: 4px;
}

.caption {
  display: block;
  margin-bottom: 8px;
  color: var(--tuna-palette-text-secondary);
}

.emptyActions {
  display: flex;
  gap: 8px;
}

.hairline {
  border-top: 2px solid var(--tuna-border-default);
  margin: 8px 0;
}

.emptyHeading {
  margin: 0;
}

.emptyBody {
  margin-top: 4px;
  color: var(--tuna-palette-text-secondary);
}
